module.exports = __webpack_public_path__ + "static/media/wizardAndCauldron.a1d1776a.gif";